import { Injectable } from '@angular/core';
import { ToastController, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class IonicToastService {
  private myToast: any;
  constructor(
    public toast: ToastController,
    public alertController: AlertController,
    private router: Router
  ) { }

  showOnceToast(statusMessage) {
    this.toast.dismiss().then((obj) => {
    }).catch(() => {
    }).finally(() => {
      this.presentToast(statusMessage);
    });
  }

  async presentToast(statusMessage) {
    const toast = await this.toast.create({
      message: statusMessage,
      position: "bottom",
      animated: true,
      duration: 3000,
      cssClass: "my-custom-class"
    });
    toast.present();
  }

  HideToast() {
    this.myToast = this.toast.dismiss();
  }

  async showAlertConfirm(header1, message1, alertId) {
    if (alertId === 1) {
      const alert = await this.alertController.create({
        header: header1,
        message: message1,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              // console.log("okay clicked");
              if (alertId === 1) {
                this.router.navigateByUrl('/logout', { replaceUrl: true });
              } else {
                // console.log("okay clicked");
              }
            }
          }, {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
          }
        ]
      });
      await alert.present();
    } else {
      const alert = await this.alertController.create({
        header: header1,
        message: message1,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              // console.log("okay clicked");
            }
          }
        ]
      });
      await alert.present();
    }
  }
}
